// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React from 'react';
import {Agree_dialog, i_agree_dlg_props} from '../../shared/agree_dialog/agree_dialog';
import {Trans} from 'react-i18next';

const T = props=><Trans components={{Legal_link: <a href="/legal"
  rel="noopener noreferrer"></a>}} {...props}/>;
export const Haff_agree_dialog = (props:i_agree_dlg_props)=>{
    const list_items = ['legal', 'resources', 'info', 'opt_out']
        .map(key=><T key={key} i18nKey={`haffnetwork.consent.${key}`}/>);
    const after_cta_text = <T i18nKey="haffnetwork.consent.after_cta"/>;
    const btn_text = <T i18nKey="haffnetwork.consent.btn_text"/>;
    return <Agree_dialog {...props} width={767} list_items={list_items}
      after_cta_text={after_cta_text} btn_text={btn_text}
      logo="logo_hola.svg"/>;
};
